export default __webpack_public_path__ + "static/media/humaaan.d43a9a86.svg";